import server from '@/request';

// 分页获取
export const getGoodsUnitLists = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/goodsUnit/pageList', data);
};

// 添加
export const addGoodsUnit = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/goodsUnit/add', data);
};

// 编辑
export const updateGoodsUnit = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/goodsUnit/update', data);
};

// 批量删除
export const deleteGoodsUnit = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/goodsUnit/batchDelete', data);
};
